<!--
 * @描述: 
 * @作者: 
 * @时间: Do not edit
-->
<template>
  <div>
    <wx-open-launch-weapp id="launch-btn" :username="env.originId" :path="url" @launch="launch">
      <slot></slot>
    </wx-open-launch-weapp>
  </div>
</template>

<script>
import env from '../config/env'
export default {
  props: {
    url:{
      type:String,
      default:""
    },
  },
  data() {
    return {
      env: env,
    }
  },
  methods:{
    launch(){
      this.$emit('launch')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
